import {
  WORKFLOW_MESSAGE_TYPE_EMAIL,
  WORKFLOW_MESSAGE_TYPE_SMS
} from 'Api/beAutomationApi'
import {
  //
  WORKFLOW_ACTIVITY_ACTION_CLICKED,
  WORKFLOW_ACTIVITY_ACTION_NOT_CLICKED,
  WORKFLOW_ACTIVITY_ACTION_NOT_OPENED,
  //
  WORKFLOW_ACTIVITY_ANY_MESSAGE,
  WORKFLOW_ACTIVITY_LAST_5_MESSAGES,
  WORKFLOW_CONDITION_CONTAINS,
  WORKFLOW_CONDITION_EQUALS,
  WORKFLOW_CONDITION_GREATER_EQUAL_THAN,
  WORKFLOW_CONDITION_GREATER_THAN,
  //
  WORKFLOW_CONDITION_IS_TODAY,
  WORKFLOW_CONDITION_LESSER_EQUAL_THAN,
  WORKFLOW_CONDITION_LESSER_THAN,
  WORKFLOW_CONDITION_MINUS_X_DAYS_IS_TODAY,
  WORKFLOW_CONDITION_NOT_EQUAL,
  WORKFLOW_CONDITION_PLUS_X_DAYS_IS_TODAY,
  WORKFLOW_CONDITION_PLUS_X_HOURS_IS_NOW,
  WORKFLOW_START_TYPE_ACTIVITY,
  WORKFLOW_START_TYPE_EVENT,
  WORKFLOW_START_TYPE_GROUP,
  WORKFLOW_START_TYPE_SUBSCRIBER_FIELD,
  WORKFLOW_START_TYPE_SUBSCRIPTION_DATE
} from 'Constants'
import { WORKFLOW_START_TYPE_FILTERS } from 'Constants/index'
import { regexEmail, regexIsIntegerNumberNotEmpty } from 'mailup-react-helpers'

import {
  TRUSTED_EMAIL_INPUT_VARIANT_UNVERIFIED,
  TRUSTED_SMS_BOX_CODE_VARIANT_INVALID
} from 'mailup-web-components'

export const validateStep2 = (
  step2,
  startType,
  trustedInputVariant,
  smsVariant,
  fieldTypeExistingFilter,
  activityTypeExistingFilter
) => {
  return (
    validateStep2Common(step2, trustedInputVariant, smsVariant) &&
    validateStep2Start(
      step2,
      startType,
      fieldTypeExistingFilter,
      activityTypeExistingFilter
    )
  )
}

export const validateStep2Common = (
  { Name, FromName, FromEmail, ReplyTo },
  trustedInputVariant,
  smsVariant
) => {
  return (
    !!Name &&
    !!FromName &&
    FromEmail.match(regexEmail) &&
    ReplyTo.match(regexEmail) &&
    trustedInputVariant !== TRUSTED_EMAIL_INPUT_VARIANT_UNVERIFIED &&
    (smsVariant !== '' // solo se SMS è obbligatorio
      ? smsVariant !== TRUSTED_SMS_BOX_CODE_VARIANT_INVALID
      : true)
  )
}

export const validateStep2Start = (
  workflow,
  startType,
  fieldTypeExistingFilter,
  activityTypeExistingFilter
) => {
  switch (startType) {
    case WORKFLOW_START_TYPE_EVENT:
      return validateStep2StartTypeEvent(workflow)
    case WORKFLOW_START_TYPE_SUBSCRIPTION_DATE:
      return validateStep2StartTypeSubscriptionDate(workflow)
    case WORKFLOW_START_TYPE_SUBSCRIBER_FIELD:
      return validateStep2StartTypeSubscriberField(
        workflow,
        fieldTypeExistingFilter
      )
    case WORKFLOW_START_TYPE_GROUP:
      return validateStep2StartTypeGroup(workflow)
    case WORKFLOW_START_TYPE_ACTIVITY:
      return validateStep2StartTypeActivity(
        workflow,
        activityTypeExistingFilter
      )
    case WORKFLOW_START_TYPE_FILTERS:
      return validateStep2StartTypeFilters(workflow)
  }
}

export const validateStep2StartTypeEvent = ({
  IdField,
  FieldType,
  IdFieldFilter,
  FieldValue
}) => {
  const validFieldValue =
    IdFieldFilter === WORKFLOW_CONDITION_IS_TODAY
      ? true
      : `${FieldValue}`.match(regexIsIntegerNumberNotEmpty)
  return !!IdField && !!FieldType && !!IdFieldFilter && validFieldValue
}

export const validateStep2StartTypeSubscriptionDate = ({ ActivityValue }) => {
  return `${ActivityValue}`.match(regexIsIntegerNumberNotEmpty)
}

export const validateStep2StartTypeGroup = ({ IdGroup }) => {
  return !!IdGroup
}

export const validateStep2StartTypeActivity = (
  { ActivityType, IdMessage, ClickedLink, ActivityValue, IdFilter },
  activityTypeExistingFilter
) => {
  const activityTypeMsgWithLinks = [
    WORKFLOW_ACTIVITY_ACTION_CLICKED,
    WORKFLOW_ACTIVITY_ACTION_NOT_CLICKED
  ]

  const activityTypesMax15 = [
    WORKFLOW_ACTIVITY_ACTION_NOT_OPENED,
    WORKFLOW_ACTIVITY_ACTION_NOT_CLICKED
  ]

  const maxDays = activityTypesMax15.includes(ActivityType) ? 15 : 90

  const validLink =
    (activityTypeMsgWithLinks.includes(ActivityType) &&
      IdMessage > 0 &&
      ClickedLink !== undefined) ||
    (ActivityType === WORKFLOW_ACTIVITY_ACTION_CLICKED &&
      [
        WORKFLOW_ACTIVITY_ANY_MESSAGE,
        WORKFLOW_ACTIVITY_LAST_5_MESSAGES
      ].includes(IdMessage)) ||
    !activityTypeMsgWithLinks.includes(ActivityType)

  const validCustomFilter =
    activityTypeExistingFilter === 'use-custom' &&
    ActivityType > 0 &&
    (IdMessage === WORKFLOW_ACTIVITY_ANY_MESSAGE ||
      IdMessage === WORKFLOW_ACTIVITY_LAST_5_MESSAGES ||
      IdMessage > 0) &&
    validLink &&
    ActivityValue >= 0 &&
    ActivityValue <= maxDays

  return (
    (activityTypeExistingFilter === 'use-custom' && validCustomFilter) ||
    IdFilter > 0
  )
}

export const validateStep2StartTypeSubscriberField = (
  { FieldType, FieldValue, IdField, IdFieldFilter, IdFilter },
  fieldTypeExistingFilter
) => {
  const conditionsWithValue = [
    WORKFLOW_CONDITION_EQUALS,
    WORKFLOW_CONDITION_GREATER_THAN,
    WORKFLOW_CONDITION_GREATER_EQUAL_THAN,
    WORKFLOW_CONDITION_LESSER_THAN,
    WORKFLOW_CONDITION_LESSER_EQUAL_THAN,
    WORKFLOW_CONDITION_NOT_EQUAL,
    WORKFLOW_CONDITION_CONTAINS,
    WORKFLOW_CONDITION_EQUALS,
    WORKFLOW_CONDITION_NOT_EQUAL,
    WORKFLOW_CONDITION_MINUS_X_DAYS_IS_TODAY,
    WORKFLOW_CONDITION_PLUS_X_DAYS_IS_TODAY,
    WORKFLOW_CONDITION_PLUS_X_HOURS_IS_NOW
  ]

  const validCustomFilter =
    fieldTypeExistingFilter === 'use-custom' &&
    // IdFilter === 0 &&
    IdField &&
    FieldType &&
    IdFieldFilter &&
    (conditionsWithValue.includes(IdFieldFilter) ? !!FieldValue : true)

  const validExistingFilter =
    fieldTypeExistingFilter === 'use-existing' && IdFilter > 0

  return validCustomFilter || validExistingFilter
}

export const validateStep2StartTypeFilters = ({
  IdsFilter,
  LastSendingPeriod,
  RecipientLimit
}) => {
  return IdsFilter.length > 0 || LastSendingPeriod > 0
}

export const step3Valid = (Step) => {
  let valid = true
  Step.forEach((el) => {
    if (el.IdMessage === -1) {
      // wait
      valid = valid === true ? !el.itemError : false
    } else {
      if (el.MessageType === WORKFLOW_MESSAGE_TYPE_EMAIL && el.IdMessage <= 0) {
        valid = false
      }
      if (el.MessageType === WORKFLOW_MESSAGE_TYPE_SMS && el.IdMessage <= 0) {
        valid = false
      }
    }
  })
  // deve essrci almeno un messaggio EMAIL/SMS
  valid = valid ? Step.find((e) => e.IdMessage >= 0) : false
  return valid
}
